import styled from 'styled-components';
import { Dropdown as SemanticDropdown, Sidebar } from 'semantic-ui-react';

import { Header, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const Message = styled(Header)`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const Dropdown = styled(SemanticDropdown)`
  &&&.ui.dropdown {
    width: 320px;
  }

  .create-new-filter-option {
    color: #477ae9 !important;
  }
`;

export const ContainerSurveyPage = styled(Sidebar.Pushable)`
  width: 100%;

  &::-webkit-scrollbar{
    display: none;
  }

  scrollbar-width: none;
`;

export const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

export const FiltersRow = styled.div`
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  gap: 15px;
  right: 45px;
  width: 100%;
  align-items: center;

  label {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const FilterLabel = styled.div`
  color: #192C47;
  font-weight: 500;
`;
